export default {"src":"/_next/static/media/FINANCIALS_IMPACT_ICON.f5d697d8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};